import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callGetExportAgent } from "../../../api/callcenters/service"
import { callExportAgent, callExportClame, callExportClameExcel } from "../../../api/export"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import moment from "moment";
import Swal from "sweetalert2";
import reports from '../../../data/reportAgent'
import { callGetAllProvince } from "../../../api/settings/service";
import DatePicker from "react-datepicker";
import { dateToString, FormatCurrencys } from "../../../utils/commonUtil";
import SmartTable from "../../../components/common/table-component";

const Index = () => {

	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', reportInsuranType: 1, startDate: '', endDate: '', provinceId: '', region: '' });
	const [dataList, setDataList] = useState([]);
	const [columns, setColumns] = useState([
	]);
	const [provinceList, setProvinceList] = useState([]);

	useEffect(() => {
		setColumns([{ label: 'clameContractNumber', key: 'contractNumber' },
		{
			label: 'clameContractFullName', style: { minWidth: '150px' }, key: 'firstName', render: (val, item) => (
				item.firstName + ' ' + item.lastName
			)
		}, {
			label: "clameAmount", style: { minWidth: '50px' }, key: 'claimAmount', render: (val) => (
				FormatCurrencys(val)
			)
		},
		{
			label: "clameTypeId", style: { minWidth: '50px' }, key: 'insuranceType', render: (val) => (
				t('insuranceType.' + val)
			)
		},
		{
			label: "clameOption", style: { minWidth: '50px' }, key: 'claimTypeId', render: (val, item) => (
				item.optionName + ' / ' + FormatCurrencys(item.packagePice)
			)
		},
		{
			label: "clameVehicleInfo", style: { minWidth: '200px' }, key: 'claimTypeId', render: (val, item) => (
				item.brandNameEn ? (item.brandNameEn + '/' + item.vehicleModel + '/' + item.licensePlate) : '-'
			)
		},
		{
			label: request.reportType == 1 ? "clameLifeDeadDate" : request.reportType == 1 ? "clameVehicleDeadDate" : "clameAllDeadDate", style: { minWidth: '50px' }, key: 'deadDate', render: (val) => (
				dateToString(val)
			)
		},
		{
			label: "clameVehicleCarriredDate", style: { minWidth: '50px' }, key: 'carriredDate', render: (val) => (
				dateToString(val)
			)
		}, {
			label: "clameVehicleCarriredName", style: { minWidth: '50px' }, key: 'carriredName', render: (val) => (
				val
			)
		}, {
			label: "clameVehicleStatus", style: { minWidth: '50px' }, key: 'status', render: (val) => (
				t('statusClame.' + val)
			)
		}
		])
		loadData();
		loadProvince();
	}, [request]);
	const loadProvince = async () => {
		const rsp = await dispatch(callGetAllProvince());
		if (rsp?.payload?.responseCode === "00000") {
			setProvinceList(rsp?.payload?.data)
		}
	}
	const loadData = async (e) => {
		let data = { ...request }
		if (e) {
			data = { ...data, ...e }
		}
		console.log(data)
		const rsp = await dispatch(callExportClame(data));
		if (rsp?.payload?.responseCode === "00000") {
			setDataList(rsp.payload.data);
		}
	};
	const handleChange = (e) => {
		const { name, value } = e.target;
		setRequest((prev) => ({ ...prev, [name]: value }));
	};


	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const selectReportInsuranType = (e) => {
		setRequest((prev) => ({
			...prev,
			reportInsuranType: e.target.value,
		}));
	}
	const selectReportType = (e) => {
		if (e.target.value == 0) {
			setRequest((prev) => ({
				...prev,
				reportType: e.target.value,
				region: '',
				provinceId: ''
			}));
		} else if (e.target.value == 1) {
			setRequest((prev) => ({
				...prev,
				reportType: e.target.value,
				provinceId: ''
			}));
		}
		else if (e.target.value == 2) {
			setRequest((prev) => ({
				...prev,
				reportType: e.target.value,
				region: '',
			}));
		}
	}


	const downloadExcel = async () => {
		try {
			let data = { ...request, maxResult: dataList?.totalRecords || 10 }
			let response = await callExportClameExcel(data);
			console.log("response", response)
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text330", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.report.claimInsurance")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={request.startDate}
														onChange={date => setRequest((prev) => ({
															...prev,
															startDate: moment(date).format('YYYY-MM-DD'),
														}))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={request.endDate}
														onChange={date => setRequest((prev) => ({
															...prev,
															endDate: moment(date).format('YYYY-MM-DD'),
														}))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>
												<div className="col-md-3">
													<div className="form-group">
														<label>{t('search.keyword')}</label>
														<input
															type="text"
															name="keyword"
															className="form-control-uld"
															placeholder={t('search.keyword') + "..."}
															onChange={handleChange}
															value={request.keyword}
															autoComplete="off"
															required />
													</div>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('report.customer.reportTypeInsuranName')}</label>
													<select className="chosen-single form-select"
														onChange={selectReportInsuranType}
														value={request.reportInsuranType}
													>
														{
															reports.reportTypeInsuran.map((item) => (
																<option key={item.id} value={item.id}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												<div className="col-md-3 form-group">
													<label>{t('report.customer.reportTypeName')}</label>
													<select className="chosen-single form-select"
														onChange={selectReportType}
														value={request.reportType}
													>
														{
															reports.reportTypeVehicle.map((item) => (
																<option key={item.id} value={item.id}>{t(item.name)}</option>
															))
														}
													</select>
												</div>
												{
													request.reportType == 1 ?
														<div className="col-md-3 form-group">
															<label>{t('report.customer.region.name')}</label>
															<select className="chosen-single form-select"
																onChange={e => setRequest((prev) => ({
																	...prev,
																	region: e.target.value,
																}))}
																value={request.region}
															>
																{
																	reports.region.map((item) => (
																		<option key={item.key} value={item.key}>{t(item.name)}</option>
																	))
																}
															</select>
														</div> : null
												}
												{request.reportType == 2 && < div className="col-md-3 form-group">
													<label>{t('search.province')}</label>
													<select className="chosen-single form-select"
														onChange={handleChange}
														name="provinceId"
														value={request.provinceId}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															provinceList.map((item) => (
																<option key={item.provinceId} value={item.provinceId}>{item.provinceName}</option>
															))
														}
													</select>
												</div>}
												<div className="col-auto auto-button">
													<label style={{ marginTop: 6 }}>&nbsp;</label>
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<SmartTable columns={columns} data={dataList} keyword={request.keyword} onLazyLoad={loadData}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
